import React, { forwardRef } from "react";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@mui/icons-material";
import axios from "axios";
import { attachRefreshInterceptor } from "./tokenRefresh";
//const api_URL = "http://34.211.31.84:8174/";
//const api_URL = "http://35.80.198.152:8174/";
//const api_URL = "http://localhost/reactenterprise/";
//const api_URL = "http://localhost/DISPENSINGMAIN/dispensing-mock/backend/";

//const api_URL = "http://localhost/"+process.env.REACT_APP_BASE_NAME + "/backend/";
const api_URL = process.env.REACT_APP_API_URL;

const backendAxios = axios.create({
  baseURL: api_URL,
  withCredentials: true,
});

const MUTATING_METHODS = ["post", "put", "patch", "delete"];
backendAxios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const method = (config.method || "get").toLowerCase();
  if (MUTATING_METHODS.includes(method)) {
    const csrf = sessionStorage.getItem("csrf_token");
    if (csrf) {
      config.headers["X-CSRF-Token"] = csrf;
    }
  }
  return config;
});

attachRefreshInterceptor(backendAxios);

export default {
  tableicons() {
    const tableIcons = {
      Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
      Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
      Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
      Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} />
      )),
      DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
      )),
      Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
      Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
      Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
      FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
      LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
      NextPage: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
      )),
      PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
      )),
      ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
      Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
      SortArrow: forwardRef((props, ref) => (
        <ArrowDownward {...props} ref={ref} />
      )),
      ThirdStateCheck: forwardRef((props, ref) => (
        <Remove {...props} ref={ref} />
      )),
      ViewColumn: forwardRef((props, ref) => (
        <ViewColumn {...props} ref={ref} />
      )),
    };
    return tableIcons;
  },

  async postApi(url, body) {
    let res = await backendAxios
      .post(url, body)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // Surface server JSON body on 4xx/5xx so callers can read success/message/status uniformly.
        if (error && error.response && error.response.data) {
          return error.response.data;
        }
        return { success: 0, message: error && error.message ? error.message : "Network error" };
      });

    return res;
  },

  async postAuthApi(url, body) {
    let res = await backendAxios
      .post(url, body, {
        headers: { "Access-Control-Allow-Origin": "*" },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });

    return res;
  },

  authToken() {
    return sessionStorage.getItem("token");
  },

  async getAuthApi(url, body) {
    let res = await backendAxios.get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });

    return res;
  },
};
